(() => {
  function priceDuos(root = document) {
    root.querySelectorAll('[data-duo-aud]').forEach(card => {
      const currency = card.dataset.currency || 'AUD';
      const rate = currency === 'AUD' ? 1 : Number(window.Shopify?.currency?.rate);
      if (!Number.isFinite(rate) || rate <= 0) return;
      const converted = Number(card.dataset.duoAud) * rate;
      const cents = currency === 'USD' ? Math.ceil(converted / 100) * 100 : Math.round(converted);
      card.dataset.price = String(cents);
      const digits = currency === 'USD' ? 0 : 2;
      card.querySelector('[data-card-price]').textContent = new Intl.NumberFormat('en-US', {style:'currency', currency, currencyDisplay:'narrowSymbol', minimumFractionDigits:digits, maximumFractionDigits:digits}).format(cents / 100) + ' ' + currency;
    });
  }
  priceDuos();
  class MobileCatalog extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('.nc-m-card')];
      this.grid = this.querySelector('[data-grid]');
      this.sort = this.querySelector('select');
      this.links = [...this.querySelectorAll('[data-filter]')];
      this.isSets = this.dataset.isSets === 'true';
      this.readURL();
      this.onHistory = () => { this.readURL(); this.apply(); };
      window.addEventListener('popstate', this.onHistory);
      window.addEventListener('hashchange', this.onHistory);
      this.links.forEach(link => link.addEventListener('click', e => {
        if (e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
        const url = new URL(link.href);
        if (url.pathname !== location.pathname) return;
        e.preventDefault();
        this.filter = link.dataset.filter;
        this.sort.value = 'featured';
        history.pushState({}, '', url);
        this.apply();
      }));
      this.sort.addEventListener('change', () => {
        const url = new URL(location.href);
        if(this.sort.value === 'featured') url.searchParams.delete('sort_by');
        else url.searchParams.set('sort_by', this.sort.value);
        history.replaceState({}, '', url); this.apply();
      });
      this.apply();
    }
    disconnectedCallback() {
      window.removeEventListener('popstate', this.onHistory);
      window.removeEventListener('hashchange', this.onHistory);
      this.ready = false;
    }
    readURL() {
      const url = new URL(location.href);
      const requested = url.searchParams.get('category');
      this.filter = this.isSets ? 'sets' : ['dinnerware','cutlery','drinkware'].includes(requested) ? requested : location.hash === '#singles' ? 'singles' : 'all';
      const sort = url.searchParams.get('sort_by');
      this.sort.value = ['price-ascending','price-descending','title-ascending'].includes(sort) ? sort : 'featured';
    }
    apply() {
      priceDuos(this);
      let cards = [...this.cards], count = 0;
      if(this.sort.value === 'price-ascending') cards.sort((a,b) => +a.dataset.price - +b.dataset.price);
      if(this.sort.value === 'price-descending') cards.sort((a,b) => +b.dataset.price - +a.dataset.price);
      if(this.sort.value === 'title-ascending') cards.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title));
      cards.forEach(card => {
        const match = this.filter === 'all' || (this.filter === 'singles' ? card.dataset.category !== 'sets' : card.dataset.category === this.filter);
        card.hidden = !match; if(match) count++;
        this.grid.append(card);
      });
      this.querySelector('[data-count]').textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
      const headings = {all:'Shop all',sets:'Shop sets',singles:'Shop pieces',dinnerware:'Plates & bowls',cutlery:'Cutlery',drinkware:'Mugs & cups'};
      this.querySelector('h1').textContent = headings[this.filter];
      document.querySelectorAll('form[action*="localization"] input[name="return_to"]').forEach(input => { input.value = location.pathname + location.search + location.hash; });
      this.links.forEach(link => {if(link.dataset.filter === this.filter) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');});
    }
  }
  if(!customElements.get('nc-mobile-catalog')) customElements.define('nc-mobile-catalog', MobileCatalog);
  document.addEventListener('shopify:section:load', e => priceDuos(e.target));
})();
